import { TypologyAndCriteriaData } from '@/api/theHive/criteriaGroups/types';
import { ListTypologyData } from '@/api/theHive/typology/types';
import { IconEditMS } from '@/constants/icons';
import { Box, IconButton, TableBody, TableHead, TableRow } from '@mui/material';
import { useMemo } from 'react';

import {
  presentCategoriesTableData,
  presentCriteriasHeander,
} from './presenter';
import {
  CategoryTitle,
  StyledHeaderTableRow,
  StyledTable,
  StyledTableCell,
  StyledTableContainer,
} from './styles';

interface CriteriasTableProps {
  criteriasData: TypologyAndCriteriaData | undefined;
  onEditService?: (service: ListTypologyData) => void;
}

export function CriteriasTable({
  criteriasData,
  onEditService,
}: CriteriasTableProps): JSX.Element {
  const categoryTables = useMemo(() => {
    if (!criteriasData) return [];
    return presentCategoriesTableData(criteriasData);
  }, [criteriasData]);

  return (
    <Box>
      {categoryTables.map((categoryTable) => (
        <Box key={String(categoryTable.category)}>
          {categoryTable.categoryLabel && (
            <CategoryTitle>{categoryTable.categoryLabel}</CategoryTitle>
          )}
          <StyledTableContainer>
            <StyledTable size="small">
              <TableHead>
                <StyledHeaderTableRow>
                  {presentCriteriasHeander.map((cell) => (
                    <StyledTableCell key={cell.id}>
                      {cell.label}
                    </StyledTableCell>
                  ))}
                  {onEditService && <StyledTableCell>Ações</StyledTableCell>}
                </StyledHeaderTableRow>
              </TableHead>
              <TableBody>
                {categoryTable.rows.map((row) =>
                  row.subRows.map((subRow, index) => (
                    <TableRow key={`${row.id}-${index + 1}`}>
                      {index === 0 && (
                        <StyledTableCell
                          rowSpan={row.subRows.length}
                          component="th"
                          scope="row"
                          sx={{
                            verticalAlign: 'center',
                            fontWeight: 'bold',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {row.code}
                        </StyledTableCell>
                      )}
                      <StyledTableCell>{subRow.serviceLabel}</StyledTableCell>
                      <StyledTableCell>{subRow.dimension}</StyledTableCell>
                      {index === 0 && (
                        <>
                          <StyledTableCell rowSpan={row.subRows.length}>
                            {row.reportType}
                          </StyledTableCell>
                          <StyledTableCell
                            rowSpan={row.subRows.length}
                            sx={{ whiteSpace: 'nowrap' }}
                          >
                            {row.price}
                          </StyledTableCell>
                          <StyledTableCell
                            rowSpan={row.subRows.length}
                            sx={{ whiteSpace: 'nowrap' }}
                          >
                            {row.deadline}
                          </StyledTableCell>
                          {onEditService && (
                            <StyledTableCell
                              rowSpan={row.subRows.length}
                              sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                            >
                              <IconButton
                                onClick={() => onEditService(row.service)}
                                color="primary"
                                title="editar serviço"
                                sx={{ '&:hover': { color: 'secondary.main' } }}
                              >
                                {IconEditMS}
                              </IconButton>
                            </StyledTableCell>
                          )}
                        </>
                      )}
                    </TableRow>
                  ))
                )}
              </TableBody>
            </StyledTable>
          </StyledTableContainer>
        </Box>
      ))}
    </Box>
  );
}
